// extracted by mini-css-extract-plugin
export default {"addCategory":"ProductionSection_addCategory__Dv3Sz","placeHolderShimmer":"ProductionSection_placeHolderShimmer__4U+Iz"};